import { Branding } from '@tv3/models/account/branding'
import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './preferences.reducer'
import * as state from './preferences.state'
import * as R from 'ramda'
import { Preference } from '@tv3/store/preferences/preferences.model'

export const preferenceState = createFeatureSelector<state.State>('preference')

export const selectAllPreferences = createSelector(preferenceState, reducer.selectAll)

export const selectPreferences = createSelector(
  selectAllPreferences,
  (preferences) => new Preference(R.head(preferences))
)

export const selectPreferencesLoaded = createSelector(preferenceState, (state: state.State) => {
  return state.isLoaded
})

export const selectDoubleBookingPreference = createSelector(selectPreferences, (preferences) => {
  return preferences.doubleBooking
})

export const selectIsDoubleBookingDisabled = createSelector(selectDoubleBookingPreference, (doubleBooking) => {
  return doubleBooking !== 1
})

export const selectBrandingPreference = createSelector(selectPreferences, (preferences) => {
  return preferences.branding || new Branding()
})
